query allUltimatePlayers(
  $first: Int,
  $offset: Int,
  $filter: UltimatePlayerFilter,
  ) {
  players: allUltimatePlayers(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      teamId
      name
      player {
        name
        playerId
        source
        playerIndex
      }
    }
    totalCount
  }
}
